<template>
  <div class="customers-tab">
    <el-row>
      <el-col :span="profile.role !== 'gerente_dealer' ? 22 : 24">
        <form-tabs
          :tabs-label-header="headerTabs"
          @onClickTab="onChangeTab"/>
      </el-col>
      <el-col
        v-if="profile.role !== 'gerente_dealer'"
        :span="2">
        <el-button
          class="add"
          @click="onCreateClick">
          <i class="icon-plus"/>
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <div class="content">
          <router-view/>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import FormTabs from '@/components/_shared/form-tabs'

export default {
  name: 'CustomersTabs',
  components: {
    FormTabs
  },
  computed: {
    profile () {
      return this.$store.getters['profile/me']
    },
    headerTabs () {
      let headers = [
        {
          name: 'Información',
          active: 'customers-info'
        },
        {
          name: 'Equipos',
          active: 'customers-tractors-table'
        },
        {
          name: 'Oportunidades',
          active: 'customers-opportunity-table'
        }
      ]
      if (this.profile.role !== 'gerente_dealer') {
        headers.push(
          {
            name: 'Tareas',
            active: 'customers-task-table'
          },
          {
            name: 'Notas',
            active: 'customers-notes-cards'
          }
        )
      }
      return headers
    }
  },
  methods: {
    onChangeTab (val) {
      for (let name in this.headerTabs) {
        if (val.label === this.headerTabs[name].name) {
          this.$router.push({...this.$route, query: {}, name: this.headerTabs[name].active})
        }
      }
    },
    onCreateClick () {
      this.$emit('isCreate', false)
      switch (this.$router.currentRoute.name) {
        case 'customers-info':
          this.$store.dispatch('app/toggleClientPanel')
          break
        case 'customers-tractors-table':
          this.$store.dispatch('app/toggleTractorPanel')
          break
        case 'customers-opportunity-table':
          this.$store.dispatch('app/toggleOpportunityPanel')
          break
        case 'customers-task-table':
          this.$store.dispatch('app/toggleTasksPanel')
          break
        case 'customers-notes-cards':
          this.$store.dispatch('app/toggleNotesPanel')
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.customers-tab{
  .add{
    width: 100%;
    border-right: 0;
    border-top: 0;
    border-radius: 0;
  }
  .content{
    background-color: #ffffff;
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/customers/customers-tabs.vue